import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { validateIntegerParam } from '@/middleware/validateIntegerParam';
import { Videos } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Videos.Pages.VIDEOS}`,
    name: Videos.Pages.VIDEOS,
    component: () => import(/* webpackChunkName: "videos" */ './views/Videos.vue'),
    meta: {
      access_roles: RouteRoles[Videos.Pages.VIDEOS],
    },
  },
  {
    path: `/${Videos.Pages.VIDEO_DETAIL}/:id`,
    name: Videos.Pages.VIDEO_DETAIL,
    beforeEnter: validateIntegerParam('id'),
    component: () => import(/* webpackChunkName: "video-detail" */ './views/VideoDetail.vue'),
    meta: {
      access_roles: RouteRoles[Videos.Pages.VIDEO_DETAIL],
    },
  },
];

export default routes;
